<script>
import { getColorFromName, getTextColorForBackground } from '../../helper/avatarHelper';

export default {
  name: 'Avatar',
  props: {
    username: {
      type: String,
      default: '',
    },
    size: {
      type: Number,
      default: 40,
    },
    isRandomBgColor: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    style() {
      const baseStyle = {
        fontSize: `${Math.floor(this.size / 2.5)}px`,
        width: `${this.size}px`,
        height: `${this.size}px`,
      };

      if (this.isRandomBgColor) {
        const bg = getColorFromName(this.username);
        baseStyle.backgroundColor = bg;
        baseStyle.color = getTextColorForBackground(bg); // <-- NEW
      }

      return baseStyle;
    },
    userInitial() {
      const parts = this.username.split(/[ -]/);
      let initials = parts.reduce((acc, curr) => acc + curr.charAt(0), '');

      if (initials.length > 2 && initials.search(/[A-Z]/) !== -1) {
        initials = initials.replace(/[a-z]+/g, '');
      }
      return initials.substring(0, 2).toUpperCase();
    },
  },
};
</script>

<template>
  <div
    class="avatar-container"
    :class="!isRandomBgColor ? 'avatar-color dark:dark-avatar-color' : ''"
    :style="style"
    aria-hidden="true"
  >
    <slot>{{ userInitial }}</slot>
  </div>
</template>

<style scoped>
@tailwind components;
@layer components {
  .avatar-color {
    background-image: linear-gradient(to top, #c2e1ff 0%, #d6ebff 100%);
  }

  .dark-avatar-color {
    background-image: linear-gradient(to top, #135899 0%, #135899 100%);
  }
}
.avatar-container {
  @apply flex leading-[100%] font-medium items-center justify-center text-center cursor-default rounded-full text-woot-600 dark:text-woot-200;
}
</style>
